export default function hasClass(element, clazz) {
    return element.classList
        ? element.classList.contains(clazz)
        : new RegExp(`(^| )${clazz}( |$)`, 'gi').test(element.className);
}



// WEBPACK FOOTER //
// ./app/webpack/vendor/formvalidation-1.3.0/dist/es6/utils/hasClass.js